import { SummaryCard } from './SummaryCard';
export default SummaryCard;
